import _regeneratorRuntime from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { unwrap as aesKw } from '../runtime/aeskw.js';
import * as ECDH from '../runtime/ecdhes.js';
import { decrypt as pbes2Kw } from '../runtime/pbes2kw.js';
import { decrypt as rsaEs } from '../runtime/rsaes.js';
import { decode as base64url } from '../runtime/base64url.js';
import { JOSENotSupported, JWEInvalid } from '../util/errors.js';
import { bitLength as cekLength } from '../lib/cek.js';
import { importJWK } from '../key/import.js';
import checkKeyType from './check_key_type.js';
import isObject from './is_object.js';
import { unwrap as aesGcmKw } from './aesgcmkw.js';

function decryptKeyManagement(_x, _x2, _x3, _x4, _x5) {
  return _decryptKeyManagement.apply(this, arguments);
}

function _decryptKeyManagement() {
  _decryptKeyManagement = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(alg, key, encryptedKey, joseHeader, options) {
    var epk, partyUInfo, partyVInfo, sharedSecret, p2cLimit, iv, tag;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            checkKeyType(alg, key, 'decrypt');
            _context.t0 = alg;
            _context.next = _context.t0 === 'dir' ? 4 : _context.t0 === 'ECDH-ES' ? 7 : _context.t0 === 'ECDH-ES+A128KW' ? 9 : _context.t0 === 'ECDH-ES+A192KW' ? 9 : _context.t0 === 'ECDH-ES+A256KW' ? 9 : _context.t0 === 'RSA1_5' ? 32 : _context.t0 === 'RSA-OAEP' ? 32 : _context.t0 === 'RSA-OAEP-256' ? 32 : _context.t0 === 'RSA-OAEP-384' ? 32 : _context.t0 === 'RSA-OAEP-512' ? 32 : _context.t0 === 'PBES2-HS256+A128KW' ? 35 : _context.t0 === 'PBES2-HS384+A192KW' ? 35 : _context.t0 === 'PBES2-HS512+A256KW' ? 35 : _context.t0 === 'A128KW' ? 45 : _context.t0 === 'A192KW' ? 45 : _context.t0 === 'A256KW' ? 45 : _context.t0 === 'A128GCMKW' ? 48 : _context.t0 === 'A192GCMKW' ? 48 : _context.t0 === 'A256GCMKW' ? 48 : 57;
            break;

          case 4:
            if (!(encryptedKey !== undefined)) {
              _context.next = 6;
              break;
            }

            throw new JWEInvalid('Encountered unexpected JWE Encrypted Key');

          case 6:
            return _context.abrupt("return", key);

          case 7:
            if (!(encryptedKey !== undefined)) {
              _context.next = 9;
              break;
            }

            throw new JWEInvalid('Encountered unexpected JWE Encrypted Key');

          case 9:
            if (isObject(joseHeader.epk)) {
              _context.next = 11;
              break;
            }

            throw new JWEInvalid("JOSE Header \"epk\" (Ephemeral Public Key) missing or invalid");

          case 11:
            if (ECDH.ecdhAllowed(key)) {
              _context.next = 13;
              break;
            }

            throw new JOSENotSupported('ECDH with the provided key is not allowed or not supported by your javascript runtime');

          case 13:
            _context.next = 15;
            return importJWK(joseHeader.epk, alg);

          case 15:
            epk = _context.sent;

            if (!(joseHeader.apu !== undefined)) {
              _context.next = 20;
              break;
            }

            if (!(typeof joseHeader.apu !== 'string')) {
              _context.next = 19;
              break;
            }

            throw new JWEInvalid("JOSE Header \"apu\" (Agreement PartyUInfo) invalid");

          case 19:
            partyUInfo = base64url(joseHeader.apu);

          case 20:
            if (!(joseHeader.apv !== undefined)) {
              _context.next = 24;
              break;
            }

            if (!(typeof joseHeader.apv !== 'string')) {
              _context.next = 23;
              break;
            }

            throw new JWEInvalid("JOSE Header \"apv\" (Agreement PartyVInfo) invalid");

          case 23:
            partyVInfo = base64url(joseHeader.apv);

          case 24:
            _context.next = 26;
            return ECDH.deriveKey(epk, key, alg === 'ECDH-ES' ? joseHeader.enc : alg, alg === 'ECDH-ES' ? cekLength(joseHeader.enc) : parseInt(alg.slice(-5, -2), 10), partyUInfo, partyVInfo);

          case 26:
            sharedSecret = _context.sent;

            if (!(alg === 'ECDH-ES')) {
              _context.next = 29;
              break;
            }

            return _context.abrupt("return", sharedSecret);

          case 29:
            if (!(encryptedKey === undefined)) {
              _context.next = 31;
              break;
            }

            throw new JWEInvalid('JWE Encrypted Key missing');

          case 31:
            return _context.abrupt("return", aesKw(alg.slice(-6), sharedSecret, encryptedKey));

          case 32:
            if (!(encryptedKey === undefined)) {
              _context.next = 34;
              break;
            }

            throw new JWEInvalid('JWE Encrypted Key missing');

          case 34:
            return _context.abrupt("return", rsaEs(alg, key, encryptedKey));

          case 35:
            if (!(encryptedKey === undefined)) {
              _context.next = 37;
              break;
            }

            throw new JWEInvalid('JWE Encrypted Key missing');

          case 37:
            if (!(typeof joseHeader.p2c !== 'number')) {
              _context.next = 39;
              break;
            }

            throw new JWEInvalid("JOSE Header \"p2c\" (PBES2 Count) missing or invalid");

          case 39:
            p2cLimit = (options === null || options === void 0 ? void 0 : options.maxPBES2Count) || 10000;

            if (!(joseHeader.p2c > p2cLimit)) {
              _context.next = 42;
              break;
            }

            throw new JWEInvalid("JOSE Header \"p2c\" (PBES2 Count) out is of acceptable bounds");

          case 42:
            if (!(typeof joseHeader.p2s !== 'string')) {
              _context.next = 44;
              break;
            }

            throw new JWEInvalid("JOSE Header \"p2s\" (PBES2 Salt) missing or invalid");

          case 44:
            return _context.abrupt("return", pbes2Kw(alg, key, encryptedKey, joseHeader.p2c, base64url(joseHeader.p2s)));

          case 45:
            if (!(encryptedKey === undefined)) {
              _context.next = 47;
              break;
            }

            throw new JWEInvalid('JWE Encrypted Key missing');

          case 47:
            return _context.abrupt("return", aesKw(alg, key, encryptedKey));

          case 48:
            if (!(encryptedKey === undefined)) {
              _context.next = 50;
              break;
            }

            throw new JWEInvalid('JWE Encrypted Key missing');

          case 50:
            if (!(typeof joseHeader.iv !== 'string')) {
              _context.next = 52;
              break;
            }

            throw new JWEInvalid("JOSE Header \"iv\" (Initialization Vector) missing or invalid");

          case 52:
            if (!(typeof joseHeader.tag !== 'string')) {
              _context.next = 54;
              break;
            }

            throw new JWEInvalid("JOSE Header \"tag\" (Authentication Tag) missing or invalid");

          case 54:
            iv = base64url(joseHeader.iv);
            tag = base64url(joseHeader.tag);
            return _context.abrupt("return", aesGcmKw(alg, key, encryptedKey, iv, tag));

          case 57:
            throw new JOSENotSupported('Invalid or unsupported "alg" (JWE Algorithm) header value');

          case 58:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _decryptKeyManagement.apply(this, arguments);
}

export default decryptKeyManagement;